import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const query = graphql`
  query About {
    allAirtable(filter: { table: { eq: "About" } }) {
      nodes {
        data {
          title
          description
          image {
            localFiles {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`;

const About = () => {
  const {
    allAirtable: { nodes: abouts },
  } = useStaticQuery(query);

  const { title, image, description } = abouts[0].data;

  return (
    <section className={`section about`}>
      <div className={`section-center about-center`}>
        <article className="about-img">
          <GatsbyImage
            image={getImage(image.localFiles[0])}
            className="hero-photo"
            alt={title}
          />
        </article>
        <article className="about-info">
          <div className={`section-title about-title`}>
            <h2>{title}</h2>
            <div className="underline"></div>
          </div>
          <p>{description}</p>
        </article>
      </div>
    </section>
  );
};

export default About;
